import * as React from 'react';
import { Card } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';
export function BusinessHeader() {
    const t = useTranslation();
    return (React.createElement(Card.Header, { dataHook: "installed-business-apps-title", title: t('manage-apps.business-apps.card-header.title') }));
}
//# sourceMappingURL=business.apps-section-header.js.map